import { aigc } from './aigc'
import { user } from './user'
import { chat } from './chat'

export const api = {
  user,
  aigc,
  chat,
}
